import { RootStore } from '../../../../common/js/stores/root.store';
import { sendSupplyMonitoringEvent } from '../../../../common/js/supply-monitoring-events/supply-monitoring-events.service';
import { DebugLog } from '../../../../common/js/debug-log';

// Matches Ogury impression URLs on presage.io subdomains
// Pattern: /imp/[TOKEN]/[BURL_URL_ENCODED]/[SIGNATURE]
const IMPRESSION_URL_PATTERN = /https:\/\/[a-z0-9-]+\.presage\.io\/imp\/[A-Za-z0-9_-]+\/(https%3A[^/]+)\/[A-Za-z0-9_-]+/g;

const TARGET_CAMPAIGN_IDS = new Set([
  '172822',
  '176928',
  '182352',
  '182920',
  '187449',
  '187756',
  '191734',
  '198699',
  '223113',
  '224190',
  '234967',
  '234968',
  '237172',
  '239430',
  '240937',
  '240941',
  '245724',
  '246420',
  '247677',
  '257409',
  '258483',
  '260362',
  '261264',
  '261363',
  '261364',
  '261366',
  '263219',
  '266826',
  '271449',
  '274253',
  '277007',
  '277292',
  '277422',
  '277424',
  '277462',
  '277476',
  '281028',
  '281029',
  '281030',
  '281031',
  '282213',
  '282584',
  '282587',
  '282628',
  '282629',
  '282832',
  '282833',
  '282835',
  '283717',
  '284292',
  '284349',
  '284405',
  '284406',
  '284494',
  '284496',
  '285219',
  '286557',
  '286558',
  '286879',
  '286881',
  '286882',
  '286883',
  '286884',
  '287070',
  '287405',
  '287610',
  '288516',
  '288748',
  '288787',
  '288797',
  '288805',
  '288917',
  '289212',
  '289502',
  '289542',
  '289603',
  '289883',
  '289933'
]);

// TARGET_CAMPAIGN_IDS.add('36954'); // devc

export class VastImpressionDebugHandler {
  constructor(rootStore: RootStore, options: FormatOptions) {
    const campaignId = rootStore.adContextStore.adContext.campaignId;
    if (!TARGET_CAMPAIGN_IDS.has(String(campaignId))) return;

    const admLoading = options.getParameter('adm_loading');
    const admType = options.getParameter('adm_type');
    if (admLoading !== 'c' || admType !== 'video') return;

    const vastContent = options.getParameter('vast_content');
    if (!vastContent) return;

    this.sendDebugEvent(vastContent);
  }

  private extractBurls(vastContent: string): string[] {
    const results: string[] = [];

    let match: RegExpExecArray | null;
    while ((match = IMPRESSION_URL_PATTERN.exec(vastContent)) !== null) {
      results.push(decodeURIComponent(match[1]));
    }

    return results;
  }

  private sendDebugEvent(vastContent: string): void {
    try {
      const burls = this.extractBurls(vastContent);
      if (burls.length === 0) return;

      sendSupplyMonitoringEvent(
        'VAST_IMPRESSION_DEBUG' as any,
        { details: JSON.stringify({ burls }) },
        true
      );
    } catch (e) {
      DebugLog.log('VastImpressionDebugHandler failed', e as object);
    }
  }
}
